import styled from "styled-components";

const ErrorStyles = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 2em;
`;

export default ErrorStyles;
